import { render, staticRenderFns } from "./UploadedFile.vue?vue&type=template&id=24b35dc3&scoped=true&"
import script from "./UploadedFile.vue?vue&type=script&lang=js&"
export * from "./UploadedFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFile.vue?vue&type=style&index=0&id=24b35dc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b35dc3",
  null
  
)

export default component.exports